import type {ListValueEditorValidations} from './types';
import type {Validator} from 'svelte-forms';
import {isDefined} from '../../../../utils/custom-utils';


export function validatorFactory(validations: ListValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(listRequiredValidator())
    }

    validators.push(maxCountValidator(validations?.maxCount ?? Number.MAX_SAFE_INTEGER));

    return validators;
}


function listRequiredValidator(): Validator {
    return (value: Record<string, unknown>) => ({
        valid: Object.getOwnPropertyNames(value).length > 0,
        name: 'list-required'
    })
}

function maxCountValidator(maxCount: number): Validator {
    return (value: Record<string, unknown>) => ({
        valid: Object.getOwnPropertyNames(value).length <= maxCount,
        name: 'max-count'
    })
}